"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCard = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var error_details_1 = require("./error-details");
var error_icon_1 = require("./error-icon");
/**
 * Render a large error that can be used when a page resource fails to load.
 * @param props
 */
function ErrorCard(props) {
    var title = props.title, body = props.body, error = props.error;
    var _a = (0, react_1.useState)(false), showDetails = _a[0], setShowDetails = _a[1];
    return (react_1.default.createElement(StyledErrorContainer, null,
        react_1.default.createElement(core_ui_1.PopoverAnimation, { isOpen: true, direction: "up" },
            react_1.default.createElement(core_ui_1.Card, null,
                react_1.default.createElement(core_ui_1.Padding, { size: 24 },
                    react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "center", alignItems: "center", flexDirection: "column", style: { maxWidth: 500 } },
                        react_1.default.createElement(error_icon_1.ErrorIcon, null),
                        react_1.default.createElement(core_ui_1.Spacing, { height: 16 }),
                        react_1.default.createElement(core_ui_1.Text, { textAlign: "center", color: "dark", weight: 600 }, title),
                        react_1.default.createElement(core_ui_1.Spacing, { height: 4 }),
                        react_1.default.createElement(core_ui_1.Text, { textAlign: "center" }, body),
                        react_1.default.createElement(core_ui_1.Spacing, { height: 24 }),
                        react_1.default.createElement(core_ui_1.Button, { size: "secondary", onClick: function () { return setShowDetails(!showDetails); } }, showDetails ? 'Less information' : 'More information'),
                        showDetails ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(core_ui_1.Spacing, { height: 24 }),
                            react_1.default.createElement(error_details_1.ErrorDetails, { error: error }))) : null))))));
}
exports.ErrorCard = ErrorCard;
var StyledErrorContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 500px;\n  margin: 100px auto;\n"], ["\n  width: 500px;\n  margin: 100px auto;\n"])));
var templateObject_1;
